export enum TeethSelectMenuDataTest {
    Select = `teeth-select-menu_select`,
    SaveButton = `teeth-select-menu_save-button`,
}
